var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.863,6.853V10.5l2.552-1.823Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.137,10.5V6.853L2.585,8.676Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.691,3.257H6.309v8.08l3.808,2.719L12,12.711l1.883,1.345,3.808-2.719ZM7.965,4.775H12V5.947H7.965Zm8.07,6.552H7.965V10.155h8.07Zm-8.07-2.69V7.465h8.07V8.637Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.891,14.777,22,19.855V9.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,14.152,2.772,20.743H21.228Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.109,14.777,2,9.7V19.855Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenMail);
export default __webpack_public_path__ + "static/media/open_mail.03039ef87caa28d464dc9d450c52efb6.svg";
export { ForwardRef as ReactComponent };